import { EmployeeCapacityResponse, EmployeeCapacityResponseItem } from '@/types/service-response'

export class EmployeeCapacity {
  private constructor (
    readonly id: number,
    readonly capacity: string,
    readonly type: number,
    readonly ist: string,
    readonly plan: string,
    readonly MGAZ: string,
    readonly MGAZColor: string
  ) {}

  public static createListFromResponse (data: EmployeeCapacityResponse): EmployeeCapacity[] {
    return data.map((item: EmployeeCapacityResponseItem): EmployeeCapacity => {
      return new EmployeeCapacity(
        parseInt(item.Mitarbeiter),
        item.Capacited,
        item.Type,
        item.IST,
        item.Plan,
        item.MGAZ ? item.MGAZ: '',
        item.MGAZColor ? item.MGAZColor : ''
      )
    })
  }
}
